export enum CapacityKPIType {
    'Percent',
    'Available',
    'Margin',
    'SimPlan',
    'Planned',
    'Simulated'
}